import React from "react";

const Line = () => <p style={{ width: 3, height: 15, backgroundColor: "#f48114", borderRadius: 25 }} />;
export default Line;
